// extracted by mini-css-extract-plugin
export var addToCartBtn = "addToCart-module--addToCartBtn--8OkEd";
export var arrow = "addToCart-module--arrow--kI5td";
export var available = "addToCart-module--available--jSBbX";
export var buySectionContainer = "addToCart-module--buySectionContainer--YYUyv";
export var descriptionContainer = "addToCart-module--descriptionContainer--FUDPC";
export var parentDiv = "addToCart-module--parentDiv--XZm5n";
export var price = "addToCart-module--price--I03Bl";
export var soldOut = "addToCart-module--soldOut--tV6YL";
export var titleContainer = "addToCart-module--titleContainer--Kl+1P";